import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { error: Error | null };

export default class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Errore interfaccia AgrofaunaGest", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main className="fatal-error" role="alert">
        <div>
          <span>AgrofaunaGest</span>
          <h1>La sezione non è stata caricata</h1>
          <p>
            I dati non sono stati modificati. Controlla la connessione e ricarica il gestionale.
          </p>
          <button type="button" className="primary" onClick={() => window.location.reload()}>
            Ricarica gestionale
          </button>
        </div>
      </main>
    );
  }
}
